import type { Fetch } from '../../shared/types';
import type { PaginatedResponse, TransferApp } from '../types';

async function fetchPrivateTransferApps(
  fetch: Fetch,
  accountId?: number,
  url = '/v1/trigger-implementations-meta/private/'
): Promise<TransferApp[]> {
  try {
    if (!accountId) {
      return [];
    }

    const { next, results } = await fetch<PaginatedResponse<TransferApp>>(url, {
      headers: {
        'x-account-id': String(accountId),
      },
    });
    if (next) {
      return results.concat(
        await fetchPrivateTransferApps(fetch, accountId, next)
      );
    }
    return results;
  } catch (error) {
    console.error('error fetching private transfer apps', error);
    throw error;
  }
}

interface RequestData {
  accountId?: number;
}

export const getPrivateTransferApps = async (
  fetch: Fetch,
  { accountId }: RequestData
): Promise<TransferApp[]> => fetchPrivateTransferApps(fetch, accountId);

export default getPrivateTransferApps;
